import { isDevMode, Provider } from "@angular/core";
import { localesDictionary } from "@dcc/shared/util-locale-manager";
import { provideTransloco } from "@jsverse/transloco";
import { TranslocoHttpLoader } from "./transloco-loader.service";

export function provideTranslocoSetup(): Provider[] {
    return [
        provideTransloco({
            config: {
                defaultLang: "en",
                availableLangs: Object.keys(localesDictionary), // We might need this in a configuration file,
                prodMode: !isDevMode(),
                reRenderOnLangChange: true,
            },
            loader: TranslocoHttpLoader
        })
    ];
}
